import { IHoleResult } from '../../../../../../store/admin/holeResults/store';

export const isHoleResult = (item: any): item is IHoleResult =>
  (item as IHoleResult).hole !== undefined;
